import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'lib-ais-common',
    template: `
    <p>
      ais-common works!
    </p>
  `,
    styles: [],
    standalone: false
})
export class AisCommonComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
